import React from "react";

const ArrowCircleLeft = ({ style = {} }) => (
  <svg
    style={style}
    width="36"
    height="35"
    viewBox="0 0 36 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.793 31.9205C25.7275 31.9205 32.1597 25.4883 32.1597 17.5537C32.1597 9.61922 25.7275 3.18701 17.793 3.18701C9.85847 3.18701 3.42627 9.61922 3.42627 17.5537C3.42627 25.4883 9.85847 31.9205 17.793 31.9205Z"
      stroke="#A9AEB4"
      strokeWidth="2.25176"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.6035 22.6252L14.5464 17.5538L19.6035 12.4823"
      stroke="#A9AEB4"
      strokeWidth="2.25176"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowCircleLeft;
